import { render, staticRenderFns } from "./historical-transaction-inquiry.vue?vue&type=template&id=6a2e0ace&scoped=true&"
import script from "./historical-transaction-inquiry.vue?vue&type=script&lang=js&"
export * from "./historical-transaction-inquiry.vue?vue&type=script&lang=js&"
import style0 from "./historical-transaction-inquiry.vue?vue&type=style&index=0&id=6a2e0ace&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2e0ace",
  null
  
)

export default component.exports